import React from "react";
import { withTranslation } from "react-i18next";
import { TaxDataInvoicingView } from "../../views";
import {
  LocalStorageService,
  ContractService,
  TaxDataService,
  InvoiceUsePersonTypeService,
  PersonTypeService,
  InvoiceService,
} from "../../../services/index";
import { TaxDataInvoicingValidator } from "../../../validators";
import { withRouter } from "react-router";

class TaxDataInvoincingAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      businessName: "",
      organization: "",
      rfc: "",
      street: "",
      colony: "",
      township: "",
      state: "",
      zipCode: "",
      email: "",
      personTypeCheck: false,
      title: props.t("taxDataInvoicingView.titleDataInvoicing"),
      description: props.t("taxDataInvoicingView.description"),
      useInvoice: "",
      labelComboBox: props.t("taxDataInvoicingView.labelInvoicing"),
      // errorBusinessName: false,
      invoiceUseOptions: [],
      contract: [],
      contractSelect: {},
      taxData: [],

      checked: false,

      physicalPerson: false,
      moralPerson: false,

      personType: "",

      personTypeId: 0,
      invoiceUsePhysical: [],
      invoiceUseMoral: [],

      descriptionPlan: "",
      pricingPlan: "",
      paymentMethod: "",
      iva: "",
      subtotal: "",
      total: "",
      contractId: "",
      invoiceCombo: "",

      taxDataUserInEdit: undefined,

      errorOrganization: false,
      errorRfc: false,
      errorStreet: false,
      errorColony: false,
      errorTownship: false,
      errorState: false,
      errorZipCode: false,

      showLoadingRequest: false,
      showCompletedRequest: false,
      showErrorRequest: false,

      message: null,
    };
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  validator = TaxDataInvoicingValidator(this.props.t);
  contractService = new ContractService(this.url);
  taxDataService = new TaxDataService(this.url);
  personTypeService = new PersonTypeService(this.url);
  invoiceUsePersonTypeService = new InvoiceUsePersonTypeService(this.url);
  invoiceService = new InvoiceService(this.url);

  async componentDidMount() {
    this.setState({ loading: true });
    try {
      let contractInfo = this.props.location.params.dataItem;
      this.token =
        this.localStorageService.getLocalStorageItem("token").idToken;
      let user = this.localStorageService.getLocalStorageItem("user");
      //Contract service, invoice use information
      let contractsClient = await this.contractService.getContractsByClientId(
        this.token
      );

      //Tax data service, name or business reason
      let taxDataUser = await this.taxDataService.getTaxDataByUser(this.token);

      //Person type service
      let personTypeInfo = await this.personTypeService.getPersonTypeById(
        user.userMetaData.userA3Cloud.client.personTypeId,
        this.token
      );

      //Invoice options service
      let invoicesUse =
        await this.invoiceUsePersonTypeService.getAllInvoiceUsePersonTypes(
          this.token
        );

      //Price formatting
      let formatter = new Intl.NumberFormat(
        "en-MX",
        { style: "currency", currency: "MXN", currencyDisplay: "narrowSymbol" },
        {
          style: "currency",
          currency: "MXN",
        }
      );

      //Filter invoiceUse by personType
      let invoicesUseInfoPhysical = invoicesUse.filter(
        (invoice) => invoice.personTypeId === 1
      );
      let invoicesUseInfoMoral = invoicesUse.filter(
        (invoice) => invoice.personTypeId === 2
      );

      this.setState({
        contractSelect: contractInfo || "",
        taxData: taxDataUser,
        personType: personTypeInfo,
        invoiceUsePhysical: invoicesUseInfoPhysical,
        invoiceUseMoral: invoicesUseInfoMoral,

        descriptionPlan: contractInfo.planLevel.plan.name,
        pricingPlan: formatter.format(contractInfo.planLevel.pricing),
        paymentMethod: contractInfo.payments[0].paymentMethod.paymentTypeId,
        iva: formatter.format(contractInfo.payments[0].iva),
        subtotal: formatter.format(contractInfo.payments[0].subtotal),
        total: formatter.format(contractInfo.payments[0].total),

        contract: contractsClient,
        loading: false,
        loadingComponent: false,
        contractId: contractInfo.contractId,
        planLevelId: contractInfo.planLevel.id,
        invoiceMonth: contractInfo.invoiceMonth,
        invoiceUseOptions: invoicesUse,

        email: user.userMetaData.userMifirma.email,
      });
    } catch (error) {
      this.props.history.push("/configuration-contracts-history");
      this.scrollWindow();
      return;
    }
  }

  /**
   * @author Lucia Alvarado
   * @description Method to move scroll
   * @memberof TaxDataInvoicingAction
   */
  scrollWindow = () => {
    window.scrollTo(0, 0);
  };

  onChange = (event) => {
    let target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.props ? target.props.name : target.name;

    this.setState({
      [name]: value,
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Change the state bussines name or rfc comboBox
   */
  onChangeComboBox = (event) => {
    let value = event.target.value;
    // if (value && value.id === undefined) {
    //   value = {
    //     ...value,
    //     id: new Date().getTime(),
    //   };
    // }
    this.setState({
      value: value,
      organization: value.organization,
      rfc: value.rfc,
      street: value.street + " " + value.number,
      colony: value.colony,
      state: value.state,
      township: value.township,
      zipCode: value.zipCode,
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Change the state to select personType
   */
  onSelectPhysicalPerson = (event) => {
    this.setState({
      personTypeId: 1,
      physicalPerson: !this.state.physicalPerson,
      moralPerson: false,
      invoiceUseOptions: this.state.invoiceUsePhysical,
      personTypeCheck: event.value,
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Change the state to select personType
   */
  onSelectMoralPerson = (event) => {
    this.setState({
      personTypeId: 2,
      moralPerson: !this.state.moralPerson,
      physicalPerson: false,
      invoiceUseOptions: this.state.invoiceUseMoral,
      personTypeCheck: event.value,
    });
  };

  // handleChangeCheckBox = (event) => {
  //   console.log('value check',  event.value )
  //   this.setState({
  //     value: event.value
  //   });
  // }

  /**
   * @author Lucia Alvarado
   * @description Change the state invoice use comboBox
   */
  onChangeComboBoxInvoiceUse = (event) => {
    let invoiceUseSelect = event.target.value;
    this.setState({
      invoiceCombo: invoiceUseSelect,
      invoiceComboId: invoiceUseSelect.id,
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Method to show the loading dialog modal
   * @memberof TaxDataInvoicingAction
   */
  toggleLoadingRequest = (value) => {
    this.setState({
      showLoadingRequest: value,
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Method to show the confirmed sign dialog modal and redirecto to home
   * @memberof TaxDataInvoicingAction
   */
  toggleCompletedRequest = (value) => {
    this.setState(
      {
        showCompletedRequest: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showCompletedRequest: false });
          this.props.history.push("/configuration-contracts-history");
        }, 4000);
      }
    );
  };

  /**
   * @author Lucia Alvarado
   * @description Method to show the error dialog modal
   * @memberof TaxDataInvoicingAction
   */
  toggleErrorRequest = (value) => {
    this.setState(
      {
        showErrorRequest: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequest: false });
        }, 4000);
      }
    );
  };

  /**
   * @author Lucia Alvarado
   * @description Method to clear and hide dialog
   * @memberof TaxDataInvoicingAction
   */
  cancel = () => {
    this.setState({
      taxDataUserInEdit: undefined,
      errorOrganization: false,
      errorRfc: false,
      errorStreet: false,
      errorColony: false,
      errorTownship: false,
      errorState: false,
      errorZipCode: false,
      errorCheckBox: false,
      rfc: "",
      street: "",
      number: "",
      colony: "",
      township: "",
      state: "",
      zipCode: "",
      organization: "",
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Create tax Data user and invoice
   */

  onSubmitUpdateUserTaxData = async (e) => {
    e.preventDefault();
    this.setState({ message: null });

    try {
      this.token =
        this.localStorageService.getLocalStorageItem("token").idToken;

      let {
        personTypeId,
        rfc,
        street,
        number,
        colony,
        township,
        state,
        zipCode,
        organization,
        contractId,
        invoiceComboId,
        planLevelId,
        invoiceMonth,
      } = this.state;

      // Validate Business Name
      let businessNameValid =
        this.validator.organizationValidator(organization);
      if (
        organization === undefined ||
        organization === "" ||
        businessNameValid !== ""
      ) {
        this.setState({ errorOrganization: true });
        return false;
      }

      // Validate street
      let streetValid = this.validator.streetValidator(street);
      if (street === undefined || street === "" || streetValid !== "") {
        this.setState({ errorStreet: true });
        return false;
      }

      // Validate colony
      let colonyValid = this.validator.colonyValidator(colony);
      if (colony === undefined || colony === "" || colonyValid !== "") {
        this.setState({ errorColony: true });
        return false;
      }

      // Validate township
      let townshipValid = this.validator.townValidator(township);
      if (township === undefined || township === "" || townshipValid !== "") {
        this.setState({ errorTownship: true });
        return false;
      }

      // Validate state
      let stateValid = this.validator.stateValidator(state);
      if (state === undefined || state === "" || stateValid !== "") {
        this.setState({ errorState: true });
        return false;
      }

      // Validate zipCode
      let zipCodeValid = this.validator.zipCodeValidator(zipCode);
      if (zipCode === undefined || zipCode === "" || zipCodeValid !== "") {
        this.setState({ errorZipCode: true });
        return false;
      }

      if (this.state.personTypeCheck === false) {
        this.setState({ errorCheckBox: true });
        return false;
      } else {
        this.setState({ errorCheckBox: false });
      }

      await this.toggleLoadingRequest(true);

      let userTaxData = {
        personTypeId,
        rfc,
        street,
        number,
        colony,
        township,
        state,
        zipCode,
        organization,
      };

      //create tax data user
      let taxDataUser = await this.taxDataService.createTaxDataUser(
        userTaxData,
        this.token
      );
      if (taxDataUser.taxDataA3cloud.statusCode === 200) {
        //create invoice
        let invoiceData = {
          contractId,
          organization,
          rfc,
          street,
          number,
          colony,
          township,
          state,
          zipCode,
          invoiceComboId,
          planLevelId,
          invoiceMonth,
        };
        let invoice = await this.invoiceService.createInvoice(
          invoiceData,
          this.token
        );

        if (invoice.statusCode === 200) {
          await this.toggleLoadingRequest(false);
          await this.toggleCompletedRequest(true);
          this.cancel();
          return true;
        } else if (invoice.statusCode === -1) {
          this.setState({
            loadingComponent: false,
            message: this.props.t("taxDataInvoicingAction.error"),
          });
          await this.toggleLoadingRequest(false);
          await this.toggleErrorRequest(true);
          this.cancel();
          return false;
        }
      } else if (taxDataUser.taxDataA3cloud.statusCode === -1) {
        this.setState({
          loadingComponent: false,
          message: this.props.t("taxDataInvoicingAction.error"),
        });
        await this.toggleLoadingRequest(false);
        await this.toggleErrorRequest(true);
        this.cancel();
        return false;
      }
      await this.toggleLoadingRequest(false);
      await this.toggleCompletedRequest(true);
      this.setState({
        loading: false,
      });
      this.cancel();
      return true;
    } catch (error) {
      await this.toggleLoadingRequest(false);
      await this.toggleErrorRequest(true);
      return false;
    }
  };

  render() {
    return (
      <TaxDataInvoicingView
        {...this.state}
        history={this.props.history}
        validator={this.validator}
        onChange={this.onChange}
        onChangeComboBox={this.onChangeComboBox}
        handleChangeCheckBox={this.handleChangeCheckBox}
        onSelectPhysicalPerson={this.onSelectPhysicalPerson}
        onSelectMoralPerson={this.onSelectMoralPerson}
        onChangeComboBoxInvoiceUse={this.onChangeComboBoxInvoiceUse}
        onSubmitUpdateUserTaxData={this.onSubmitUpdateUserTaxData}
        toggleLoadingRequest={this.toggleLoadingRequest}
        toggleCompletedRequest={this.toggleCompletedRequest}
        toggleErrorRequest={this.toggleErrorRequest}
        cancel={this.cancel}
      />
    );
  }
}

export default withRouter(withTranslation()(TaxDataInvoincingAction));
